import { uniqueId } from '../../../../lib/uniqueId';
import { getFullMetadataElementId } from './metadataElementUtils';
import type { FunnelType } from '../../../../types/enums/FunnelType';

export type MetadataElementToAdd = {
  name: string;
  type: string;
  crmOrgId: string;
  metadataId: string;
  position: FunnelMapPosition;
  color?: string;
  icon?: string;
};

export type MetadataElementConnection = {
  source: string;
  target: string;
  targetType: FunnelType;
};

/**
 * Adds metadata elements to a funnel map and optionally creates connections between them.
 * Modifies the funnelMap object in place.
 */
export function addMetadataElementsToFunnelMap(
  funnelMap: FunnelMap,
  metadataElements: MetadataElementToAdd[],
  connections?: MetadataElementConnection[],
  sectionId?: string,
): void {
  metadataElements.forEach((metadataElement) => {
    const { name, type, crmOrgId, metadataId, position, color, icon } = metadataElement;

    if (!funnelMap.metadataElementsData) {
      funnelMap.metadataElementsData = {};
    }
    if (!funnelMap.metadataElements) {
      funnelMap.metadataElements = {};
    }

    const fullMetadataId = getFullMetadataElementId({ crmOrgId, metadataId });

    funnelMap.metadataElementsData[fullMetadataId] = {
      name,
      type,
    };
    funnelMap.metadataElements[fullMetadataId] = {
      position,
      funnelLinks: [],
      metadataId,
      crmOrgId,
      color,
      icon,
      sectionId,
    };

    if (connections) {
      connections.forEach((connection) => {
        if (funnelMap.metadataElements[connection.source]) {
          funnelMap.metadataElements[connection.source].funnelLinks.push({
            _id: uniqueId(),
            _type: connection.targetType,
            funnelId: connection.target,
          });
        }
      });
    }
  });
}
